import React, { useState, useEffect, useRef } from "react";
import Header from "./header/header";
import Footer from "./Footer";
import axios from "axios";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { ClipLoader } from "react-spinners";
import { BsEmojiFrown } from "react-icons/bs";
import { Modal } from "react-bootstrap";
import { baseUrl, GetToken } from "../App";
import { IUserDetails } from "./EnrollTypes";

const GetUserDetails: React.FC = () => {
  const [ready, setReady] = useState(false);
  const [nophoneerror2, setNophoneerror2] = useState(true);
  const [showLoginbtn, setShowLoginbtn] = useState(false);
  const [geterror2, setGeterror2] = useState("");
  const [linkedphone, setLinkedphone] = useState("");
  const [userInfo, setUserInfo] = useState<any>([]);
  const [notific, setNotific] = useState("");
  const [shownotificError, setShownotificError] = useState(false);
  var stopOperation = useRef(0);
  const [showModal, setShowModal] = React.useState(false);
  const [modalContent, setModalContent] = React.useState("");


  /*
    THIS CODEBASE IS NOT IN USE. DON'T BE LIKE ME BY WASTING YOUR TIME ON IT
  */
 
  // Function to get error message based on error type
  const getErrorMessage = (error: any) => {
    if (!error.response) {
      return "Network Error: Unable to connect to the server. Please check your internet connection.";
    }
    const statusCode = error.response.status;
    switch (statusCode) {
      case 500:
        return "Oops, there is a slight issue with our server, please refresh or try again in a moment.";
      case 400:
        return "Sorry, our server cannot process your input. Please confirm your input.";
      case 403:
        return "You do not have permission to access this resource.";
      case 404:
        return "Your requested resource could not be found on the server.";
      default:
        return `Error ${statusCode}: An error occurred. Please try again later.`;
    }
  };

  const handleModalClose = () => {
    setShowModal(false);
    setModalContent(""); // Reset modal content
  };

  const todoyen2page = () => {
    setShowLoginbtn(true);
  };

  const getUserCredentials = async() => {
    stopOperation.current = 1;
    const popupWindowURL = new URL(window.location.href);
    const code = popupWindowURL.searchParams.get("code");
    await axios
      .get(`http://localhost:5000/getUserCredentials?code=${code}`)
      .then((res) => {
        const user = res.data;
        console.log("User", user);
        setUserInfo(user);
      });
  };

  const loadings = () => {
    new Promise((r) => setTimeout(r, 205));
    setReady(true);
  };

  const completeLinkedInRegistration = async (
    e: React.FormEvent<HTMLFormElement>
  ) => {
    e.preventDefault();
    if (linkedphone.length >= 6) {
      const idToken = await GetToken();
      const emailValue = {
        email: userInfo.email.emailAddress
      }

      const userResponse = await axios.post(`${baseUrl}/getusersbyfield`, emailValue, {
        headers: {
            Authorization: `Bearer ${idToken}`,
        },
      }).catch((error) => {
        if(error.response.data.code === 404 || error.response.data.status === "No matching docs")
        {
          var bodyFormData = {
            firstname: userInfo.firstname,
            lastname: userInfo.lastname,
            email: userInfo.email.emailAddress,
            phone: linkedphone,
            sourceOfDiscovery: "others",
            ProfileImage: " ",
            Referred: false,
            ReferralId: "",
            UserStatus: "User",
            newLetter: false,
            uids: " ",
            showEmail: true,
            scholarshipRecipient: false,
            scholarshipDiscount: 0,
            scholarshipUsed: false,
          };
    
          const bodyFormData2 = {
            sender: {
              name: "Doyenify Academy",
              email: "info@doyenify.com",
            },
            to: [
              {
                email: userInfo.email.emailAddress,
              },
            ],
            replyTo:{
              email:"info.doyenify@gmail.com",
            },
            subject: "You have successfully registered to Doyenify Academy",
            htmlContent: `<html><head>
          
                      <style>
                          body {
                              background-color:#696969;
                          }
                          .imgtag{
                              justify-content: center;
                              align-items: center;
                              margin-left: 45%;
                          }
                          .welcome {
                              text-align: center;
                              color: #696969;
                          }
                  
                          .content {
                              background-color: #ffffff;
                              margin: 15px;
                              padding: 20px;
                          }
                      </style>
                  </head>
                  
                  <body>
                      <div class="imgtag">
                          <img src="https://academy.doyenify.com/images/doyenifyAcademy.png" alt="img" /> 
                      </div>
                          
                      <div class="content">
                          <h2 class="welcome">{{params.username}}, Welcome to Doyenify Academy</h2>
                          
                          <p>Dear {{params.username}},</p>
                          <p>Welcome to <a href="https://academy.doyenify.com" >Doyenify Academy</a>.! We are excited to have you as a part of our community. Get ready for a fantastic journey filled with Hands-On Practical Experience</p>
                          <p>Here's a quick overview of what you can expect:
                          <ol type="1">
                              <li><span style="font-weight: 600; margin-right: 7px; color: #696969">Expert-Led Learning:</span> <p>Our courses are led by experienced industry professionals who bring their real-world insights and expertise into the classroom, giving you practical knowledge that is immediately applicable. </p>
                              </li>
                              <li><span style="font-weight: 600; margin-right: 7px; color: #696969">Hands-On Projects:</span> <p>We emphasize learning by doing. Throughout the courses, you will work on a series of hands-on projects, building a robust portfolio that showcases your skills to potential employers.</p>
                              </li>
                              <li><span style="font-weight: 600; margin-right: 7px; color: #696969">Job-Ready Skills:</span> <p>Our curriculum is carefully crafted to match the skills demanded by the job market. By the time you graduate, you will possess the coding and problem-solving abilities that employers are looking for.</p>
                              </li>
                              <li><span style="font-weight: 600; margin-right: 7px; color: #696969">Problem-Solving Focus:</span> <p> Coding is about more than just syntax; it is about finding innovative solutions. Our bootcamp hones your ability to approach complex problems creatively and analytically.</p>
                              </li>
                              <li><span style="font-weight: 600; margin-right: 7px; color: #696969">Results-Driven Approach:</span> <p>Our success is measured by your success. We are dedicated to helping you achieve your career goals and providing you with the skills to excel in the tech industry.</p>
                              </li>
                          </ol>
                          
                          <p>We are thrilled to embark on this journey with you. If you have any questions, feedback, or suggestions, do not hesitate to reach out to us at info@doyenify.com or +372 5670 4920. Remember, your experience and satisfaction are our top priorities.</p>
                          <p>Thank you for choosing <a href="https://academy.doyenify.com" >Doyenify Academy</a>. Let's help you achieve your Tech dreams!</p>
                          <p>Best regards,</p>
                          <p>DoyenifyAcademy</p>
                  
                      </div>
                  
                      
                  </body>
                  </html>
                                      
                                  `,
            params: {
              username: userInfo.firstname,
            },
          };
          const bodyFormData3 = {
            sender: {
              name: "Doyenify Academy Notification",
              email: "info@doyenify.com",
            },
            to: [
              {
                email: "info.doyenify@gmail.com",
              },
            ],
            replyTo:{
              email:"info.doyenify@gmail.com",
            },
            subject: "Newly Registered User",
            htmlContent: `<html><head></head><body>
                                      <h1>you have a newly registered user</h1>
                                      <p>student with Name: {{params.username}}, registered</p>
                                      <p>User Phone is: {{params.userphone}}</p>
                                      <p>User Email is: {{params.useremail}}</p>
                                  </body></html>`,
            params: {
              useremail: userInfo.email.emailAddress,
              username:
                userInfo.firstname + " " + userInfo.lastname,
              userphone: linkedphone,
            },
          };
    
           axios
            .post(
              `${baseUrl}/registration`,
              bodyFormData
            )
            .then(async(response) => {
              setShownotificError(false);
              setNotific("Registration successful!");

              const responseToken = await fetch("https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=" +
                process.env.REACT_APP_SERVICE_KEY, {
                method: "post",
                body: JSON.stringify({
                  email: process.env.REACT_APP_SERVICE_EMAIL,
                  password: process.env.REACT_APP_SERVICE_PASSWORD,
                  returnSecureToken: true,
                }),
                headers: {
                  "Content-Type": "application/json",
                },
              });

              const userToken = await responseToken.json();
              await axios
              .post(String(process.env.REACT_APP_SERVICE_APP_URL), bodyFormData2, {
                  headers: { Authorization: `Bearer ${userToken.idToken}` },
                }
              )
              .then()
              .catch((e) => {
                console.log("(axios) an error occurred sending mail", e)
              });

              await axios
              .post(String(process.env.REACT_APP_SERVICE_APP_URL), bodyFormData3, {
                  headers: { Authorization: `Bearer ${userToken.idToken}` },
                }
              )
              .then()
              .catch((e) => {
                console.log("(axios) an error occurred sending mail", e)
              });
              
    
              setLinkedphone("");
              setTimeout(todoyen2page, 2000);
              setNophoneerror2(true);
            })
            .catch((error) => {
              console.log(error);
              setShowModal(true);
              setModalContent(getErrorMessage(error));
            });
        }
        else{ console.log(error.response.data); return;}
      });
      let doyen:IUserDetails = userResponse?.data?.data[0];
      if(doyen){
        setShownotificError(true);
        setNotific("Account Already Exist");
        setGeterror2("");
        return;
      }
    } else {
      setGeterror2("Something wrong with the number");
    }
  };

  useEffect(() => {
    if (stopOperation.current === 0) {
      getUserCredentials();
    }
    loadings();
  }, []);

  return (
    <div>
      <Modal show={showModal} onHide={handleModalClose} centered={true}>
        <Modal.Header closeButton>
          <Modal.Title>Error</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="flex justify-center items-center align-center text-center p-2">
            <BsEmojiFrown
              size={50}
              color="#047E35"
              className="flex justify-center items-center "
            />
          </div>

          <div>{modalContent}</div>
        </Modal.Body>
      </Modal>

      {ready ? (
        <>
          <Header />

          <div className="container">
            <br />
            <br />
            <br />
            <br />

            <br />
            <br />
            <br />

            <div>
              <div className="row">
                <div className="col-md-4">
                  <div className="row myfirstcon">
                    <h4 style={{ fontWeight: "600" }}>
                      Unlock Your Potential:
                    </h4>
                    <h4 style={{ fontWeight: "600" }}>Sign Up Today!</h4>
                    <p>Take the First Step Towards Your Bright Future</p>
                    <img
                      src="../../images/enrolloneimg.png"
                      alt="enrolimg"
                      style={{ width: "100%", height: "241px" }}
                    />
                  </div>
                </div>
                <div className="col-md-8">
                  {showLoginbtn ? (
                    <></>
                  ) : (
                    <>
                      <form
                        style={{ marginTop: "100px" }}
                        onSubmit={completeLinkedInRegistration}
                      >
                        <div className="row text-center">
                          <div className="col">
                            <img
                              src={userInfo.userPic}
                              style={{ borderRadius: "10px" }}
                              alt="userpic"
                            />
                            <p>
                              Hi {userInfo.firstname} {userInfo.lastname}
                            </p>
                          </div>

                          {shownotificError ? (
                            <>
                              <h2 style={{ color: "#FF0000" }}>{notific}</h2>
                            </>
                          ) : (
                            <>
                              <h2 style={{ color: "green" }}>{notific}</h2>
                            </>
                          )}

                          <h2>
                            Please fill in the below to complete the
                            Registration
                          </h2>
                        </div>

                        <div
                          className={
                            nophoneerror2 ? "textinputsp" : "textinputs2p"
                          }
                        >
                          <PhoneInput
                            country={"ng"}
                            value={linkedphone}
                            onChange={(linkedphone) =>
                              setLinkedphone(linkedphone)
                            }
                            isValid={(value, country: any) => {
                              /* eslint-disable no-useless-escape */
                              if (
                                value.match(
                                  /^([0|\+[0-9]{1,5})?([7-9][0-9]{8})$/
                                )
                              ) {
                                return (
                                  "Invalid value: " +
                                  value +
                                  ", " +
                                  country.name
                                );
                                /* eslint-disable no-useless-escape */
                              } else if (
                                value.match(
                                  /^([0|\+[0-9]{1,5})?([7-9][0-9]{8})$/
                                )
                              ) {
                                return false;
                              } else {
                                return true;
                              }
                            }}
                          />
                        </div>

                        <p style={{ color: "#FF0000" }}>{geterror2}</p>

                        <button
                          className="btn btn-success"
                          style={{ marginBottom: "20px" }}
                          type="submit"
                        >
                          Click to Complete
                        </button>
                      </form>
                    </>
                  )}

                  {showLoginbtn ? (
                    <>
                      <div style={{ marginTop: "100px" }}>
                        <h3 style={{ textAlign: "center" }}>
                          You have already registered
                        </h3>
                        <div>
                          <div
                            style={{
                              display: "flex",
                              border: "1px solid #156614",
                              padding: "7px",
                              cursor: "pointer",
                            }}
                          >
                            <img
                              style={{ marginLeft: "30%", height: "25px" }}
                              src="../../images/Google.png"
                              alt="acadlogo"
                            />
                            <h5
                              style={{
                                paddingLeft: "12px",
                                paddingTop: "4px",
                                color: "#696969",
                              }}
                            >
                              Click, to Login with Google
                            </h5>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </div>
          </div>
          <br />
          <br />

          <Footer />
        </>
      ) : (
        <>
          <div>
            {/* <Audio
                        height="80"
                        width="80"
                        // radius="9"
                        color="green"
                        ariaLabel="loading"
                        wrapperStyle={{alignItems: "center", justifyContent: "center",verticalAlign: "middle", margin: "auto", position: "absolute",
                        top: "0", left: "0", bottom: "0", right: "0"}}
                        // wrapperClass
                        /> */}

            <div className="academystyle">
              <img src="../../images/doyenifyAcademy.png" alt="doy academy" />
              <ClipLoader size={25} color="#047E35" />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default GetUserDetails;
